/**
 * @generated SignedSource<<418b9db3ebfe2c5eab09f0478548a1f2>>
 * @relayHash e88ce4a596d33c30aa08b1a54998a1e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a8f0824af50f5ac42c072f8c2064f84e811e6abd8850563e32f852f5d5bffee

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type GroupByDropdownWithSearchQuery$variables = {
  issueSearchInput?: JiraIssueSearchInput | null | undefined;
  nodeId: string;
};
export type GroupByDropdownWithSearchQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly viewSettings?: {
      readonly groupByConfig: {
        readonly " $fragmentSpreads": FragmentRefs<"GroupByDropdownWithSearch">;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"GroupByDropdownWithSearch412BadPattern">;
  } | null | undefined;
};
export type GroupByDropdownWithSearchQuery = {
  response: GroupByDropdownWithSearchQuery$data;
  variables: GroupByDropdownWithSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "FragmentSpread",
    "name": "GroupByDropdownWithSearch412BadPattern"
  },
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GroupByDropdownWithSearch"
          }
        ]
      }
    ]
  }
],
v6 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v6/*: any*/)
],
v11 = [
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              },
              (v6/*: any*/)
            ],
            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
            "kind": "LinkedField",
            "name": "recentlyUsed",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                "kind": "LinkedField",
                "name": "availableGroupByFieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v10/*: any*/),
                "filters": [
                  "issueSearchInput",
                  "filter"
                ],
                "handle": "connection",
                "key": "RefetchIssueTableGroupByOptionsQuery_availableGroupByFieldOptions",
                "kind": "LinkedHandle",
                "name": "availableGroupByFieldOptions"
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6a8f0824af50f5ac42c072f8c2064f84e811e6abd8850563e32f852f5d5bffee",
    "metadata": {},
    "name": "GroupByDropdownWithSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "90f9acf09365f073e3b4a14f87148af9";

export default node;
